import React from 'react'
import ReactDOM from 'react-dom';
import { browserHistory } from 'react-router'
import store from './store/configureStore'
import { Provider } from 'react-redux'
import Routes from './routes'

ReactDOM.render(
  <Provider store={store}>
    <Routes history={browserHistory} />
  </Provider>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js